export default __webpack_public_path__ + "static/media/p1.a5f7b324.png";